



export function ValidateEmail(mail){  
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
}

export function getSelectedPlan(){
  const el = document.querySelector('input[name="plan"]:checked');
  if(!el) return null;

  return {
    plan: el.value,
    price: parseInt(el.dataset.price, 10)
  };
}


/*AQUI ES DONDE VEMOS SI EXISTE DIV PARA MOSTRAR CONVERSION SI NO NO*/


export async function convertirMXNaUSD(input_id, mxn) {

    const elemento = document.getElementById(input_id);

    // Mostrar "Calculando..." solo si el elemento existe
    if (elemento) {
        elemento.innerHTML = `
            <span class="loading_exchange">
                <span class="spinner"></span>
                Calculando...
            </span>
        `;
    }

    const url = "https://api.exchangerate-api.com/v4/latest/MXN";

    try {

        const res = await fetch(url);
        const data = await res.json();

        const tasa = data.rates.USD;
        const resultado = mxn * tasa;

        // Mostrar resultado solo si el elemento existe
        if (elemento) {
            elemento.innerHTML = `
                <div style="background-color:#efefef;padding:5px;border-radius:5px;">
                    💲 ${mxn} MXN <br>
                    💲 ${resultado.toFixed(2)} USD
                </div>
            `;
        }

        return resultado;

    } catch (e) {

        console.error("Error al obtener el tipo de cambio:", e);

        // Mostrar error solo si el elemento existe
        if (elemento) {
            elemento.innerHTML = `
                <span style="color:red;">
                    Error al convertir
                </span>
            `;
        }

        return null;
    }
}




export async function postJSON(url, data) {
  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });

  if (!res.ok) throw new Error("HTTP error");

  return res.json();
}




export const makeQR = (your_data, containerId) => {
      let qrcodeContainer = document.getElementById(containerId);
        qrcodeContainer.innerHTML = "";
        new QRious({
          element: qrcodeContainer,
          value: your_data,
          size: 600,
          padding:50,
        }); // generate QR code in canvas
       // downloadQR(); // function to download the image

    }






export const PLAN_LABELS = {
  199: "Bimonthly",
  499: "Annual",
  899: "4-Year"
};





export function view_plans_payment(){

  return `

  <style>
    /* 🔒 estilos mínimos garantizados SOLO para este bloque */
    .plan-wrapper{
      display:grid;
      grid-template-columns: repeat(2, 1fr);
      gap:12px;
      margin:20px 0;
    }

    @media (max-width:520px){
      .plan-wrapper{
        grid-template-columns:1fr;
      }
    }

    .plan-card{
      cursor:pointer;
      display:block;
    }

    /* 👉 la tarjeta full ocupa las 2 columnas */
    .plan-card.full{
      grid-column: 1 / -1;
    }

    .plan-card input{
      display:none;
    }

    .plan-content{
      display:flex;
      align-items:center;
      gap:15px;
      background:#fff;
      border-radius:14px;
      padding:16px 18px;
      border:2px solid transparent;
      box-shadow:0 6px 18px rgba(0,0,0,.08);
      transition:all .25s ease;
    }

    .plan-card:hover .plan-content{
      transform:translateY(-2px);
    }

    .plan-card input:checked + .plan-content{
      border-color:#f9cf40;
      background:#fff9dc;
      box-shadow:0 10px 25px rgba(249,207,64,.35);
    }

    .plan-logo{
      width:42px;
      height:42px;
      object-fit:contain;
    }

    .plan-text{
      display:flex;
      justify-content:space-between;
      width:100%;
      font-size:16px;
      font-weight:700;
      color:#111;
    }
  </style>

  <p style="margin:20px 0 10px;font-size:16px;font-weight:600;color:#fff;">
    Select the plan of your preference
  </p>

  <div class="plan-wrapper">
    <label class="plan-card">
      <input type="radio" name="plan" value="bimestral" data-price="199">
      <div class="plan-content">
        <div class="plan-text">
          <span>Bi-monthly</span>
          <span id="usd_transform">199 MXN</span> 
        </div>
      </div>
    </label>

    <label class="plan-card">
      <input type="radio" name="plan" value="anual" data-price="499">
      <div class="plan-content">
        <div class="plan-text">
          <span>Annual</span>
          <span id="usd_transform_year">499 MXN</span>
        </div>
      </div>
    </label>

    <label class="plan-card full">
      <input type="radio" name="plan" value="4years" data-price="899">
      <div class="plan-content">
        <div class="plan-text">
          <span>4 Years</span>
          <span id="usd_transform_4_year">899 MXN</span>
        </div>
      </div>
    </label>
  </div>
  `;
}